'use client';

import * as React from 'react';

import { Button, type ButtonProps } from '@/components/ui/button';
import { IconGitHub, IconGoogle, IconSpinner } from '@/components/ui/icons';
import { cn } from '@/lib/utils';
import { signIn } from 'next-auth/react';

interface LoginButtonProps extends ButtonProps {
    provider?: 'github' | 'google' | 'credentials';
    showIcon?: boolean;
    text?: string;
}

export function LoginButton({
    text = '',
    showIcon = true,
    provider = 'github',
    className,
    ...props
}: LoginButtonProps) {
    const [isLoading, setIsLoading] = React.useState(false);
    if (text === '') {
        if (provider === 'github') {
            text = 'Login with GitHub';
        } else if (provider === 'google') {
            text = 'Login with Google';
        } else {
            text = 'Login';
        }
    }

    return (
        <Button
            variant="outline"
            onClick={() => {
                setIsLoading(true);
                // next-auth signIn() function doesn't work yet at Edge Runtime due to usage of BroadcastChannel
                signIn(provider, { callbackUrl: `/` });
            }}
            disabled={isLoading}
            className={cn(className)}
            {...props}
        >
            {isLoading ? (
                <IconSpinner className="mr-2 animate-spin" />
            ) : showIcon ? (
                <>
                    {provider === 'github' && <IconGitHub className="mr-2" />}
                    {provider === 'google' && <IconGoogle className="mr-2" />}
                </>
            ) : null}
            {text}
        </Button>
    );
}
